import React from 'react'

import { IconAlertTriangle } from '@tabler/icons'

const DeleteUser = ({ toggleModal, deleteUser, user }) => {
    return (
        <div
            className="modal modal-blur fade show"
            id="modal-danger"
            tabIndex={-1}
            role="dialog"
            aria-modal="true"
            style={{ display: "block" }}
        >
            <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
                <div className="modal-content">
                    <button
                        type="button"
                        className="btn-close"
                        onClick={(e) => toggleModal(e, 'delete')}
                 
                    />
                    <div className="modal-status bg-danger" />
                    <div className="modal-body text-center py-4">
                        <IconAlertTriangle
                            className="icon-lg text-danger"
                        />
                        <h3>Are you sure?</h3>
                        <div className="text-muted">
                        {`You are about to delete ${user.name} as a user. They will no longer being able to log in`}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="w-100">
                            <div className="row">
                                <div className="col">
                                    <span href="#" className="btn w-100" onClick={(e) => toggleModal(e, 'delete')}>
                                        Cancel
                                    </span>
                                </div>
                                <div className="col">
                                    <span
                                        onClick={(e) => deleteUser(e, user)}
                                        className="btn btn-danger w-100"
                                    >
                                        Yes, delete
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default DeleteUser